export const GET_UPGRADE_REGISTRY_DETAILS = `
import AFLUpgradeRegistry from 0xAFLContracts

access(all) fun main(): AnyStruct {
    return AFLUpgradeRegistry.getAll()
}`
